module.exports = __webpack_public_path__ + "img/gentlemen-club-story-1.410588ec.png";